// Libraries
import { NgModule } from '@angular/core';

// Modules
import { FormErrorsModule } from './modules/form-errors/form-errors.module';

// Components
import { ItemBodyComponent } from './components/item/item-body.component';

// Directives
import { OnlyNumberDirective } from './directives/only-number.directive';
import { CounterUpDirective } from './directives/counter-up.directive';
import { AutofocusDirective } from './directives/auto-focus.directive';
import { ToggleClassDirective } from './directives/toggle-class.directive';
import { ItemToggleDirective } from './directives/item/item-toggle.directive';
import { ItemDirective } from './directives/item/item.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';

// Pipes
import { PercentagePipe } from './pipes/percentage.pipe';

export const MODULES = [
  FormErrorsModule
];

export const COMPONENTS = [
  ItemBodyComponent
];

export const DIRECTIVES = [
  OnlyNumberDirective,
  CounterUpDirective,
  AutofocusDirective,
  ItemToggleDirective,
  ItemDirective,
  ToggleClassDirective,
  ClickOutsideDirective
];

export const PIPES = [
  PercentagePipe
];

/**
 * `WoopaCommonModule`
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 */
@NgModule({
  declarations: [
    ...DIRECTIVES,
    ...COMPONENTS,
    ...PIPES
  ],
  exports: [
    ...DIRECTIVES,
    ...COMPONENTS,
    ...MODULES,
    ...PIPES
  ],
  imports: [
    ...MODULES
  ]
})
export class WoopaCommonModule {
}
